export const FACTORIES = [
    {
        id: "vietnam",
        label: "베트남",
        name: "베트남 공장",
        machineCount: 52,
        legacyTablePrefix: "opcua_multi_",
    },
    {
        id: "dongtan",
        label: "동탄",
        name: "동탄 공장",
        machineCount: 4,
        legacyTablePrefix: "opcua_multi_dongtan_",
    },
];
export const FACTORY_IDS = FACTORIES.map((f) => f.id);
function pad2(n) {
    return n < 10 ? `0${n}` : String(n);
}
export const MACHINES = FACTORIES.flatMap((f) => Array.from({ length: f.machineCount }, (_, i) => {
    const num = pad2(i + 1);
    return {
        factoryId: f.id,
        machineId: `M${num}`,
        label: `${f.label} ${num}호기`,
    };
}));
export function getFactory(id) {
    const f = FACTORIES.find((x) => x.id === id);
    if (!f)
        throw new Error(`unknown factory: ${id}`);
    return f;
}
export function machinesOf(factoryId) {
    return MACHINES.filter((m) => m.factoryId === factoryId);
}
